import { useQuery } from "@tanstack/react-query";
import { getOperators } from "../../../services/rules";
import { operatorsQueryKey } from "./queryKeys";

// Fetches the list of condition operators. Pure server cache, not scope, so no
// React Context needed.
export function useOperatorsQuery() {
  return useQuery({
    queryKey: operatorsQueryKey(),
    queryFn: getOperators,
    refetchOnWindowFocus: false,
  });
}
